import { t$2, u$1 } from "@/js/global/global";
import { announce } from "../global/helpers";

const { icons: icons$1 } = window.theme;
function productLightbox() {
  const lightboxImages = t$2(".lightbox-image", document);
  if (!lightboxImages.length) return;
  let productLightbox;
  import("@/js/vendor/photoswipe-chunk").then((_ref) => {
    let init = false;
    let { PhotoSwipeLightbox, PhotoSwipe } = _ref;
    productLightbox = new PhotoSwipeLightbox({
      gallery: ".lightbox-media-container",
      children: ".lightbox-image",
      pswpModule: PhotoSwipe,
      mainClass: "pswp--product-lightbox",
      bgOpacity: 1,
      arrowPrevSVG: icons$1.chevron,
      arrowNextSVG: icons$1.chevron,
      closeSVG: icons$1.close,
      zoomSVG: icons$1.zoom,
    });
    productLightbox.init();

    // Hide nav ui elements if single image
    productLightbox.on("firstUpdate", () => {
      const { pswp, options } = productLightbox;
      const productImageCount = options.dataSource.items.length;
      if (productImageCount === 1) {
        u$1(pswp.element, "pswp--is-single-image");
      }
    });
    productLightbox.on("change", () => {
      if (init === false) {
        init = true;
        return;
      }
      let current = productLightbox.pswp.currSlide.container;
      if (current) {
        let alt = current.querySelector("[alt]").getAttribute("alt");
        announce(alt);
      }
    });
  });
}

export { productLightbox };
